import {
  Component,
  OnInit
} from '@angular/core';
import * as fromFollowsPage from '@app/modules/follows-list/reducers/follows.reducer';
import * as FollowActions from '@core/actions/follow.actions';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store, select } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-followId-confirmation',
  templateUrl: './followId-confirmation.component.html',
  styleUrls: ['./followId-confirmation.component.css'],
})

export class FollowIdComponent implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    private store: Store<any>,
  ){}

  selectedFollowId = "";
  Follows = [];
  _alive = true;
  FollowIds$ = this.store.pipe(select(fromFollowsPage.getFollowsWithBUs))

  ngOnInit() { 
    this.FollowIds$.pipe(takeWhile(() => this._alive)).subscribe((f) => {
      if(this.Follows.length === 0){
        this.store.dispatch(new FollowActions.Load({}));
        if(f){
          this.Follows = f.filter((fs) => fs.ParentId !== null)
          this.Follows = this.Follows.sort((a, b) => b.id - a.id)
        }
      }
    })
  }

  acceptModal(){
    this.activeModal.dismiss(this.selectedFollowId)
  }
  
  selectFollowId(e){
    this.selectedFollowId = e.target.value
  }
}